module.exports = function(message, fn) {
  var invoked;
  invoked = false;
  return function() {
    if (invoked) {
      throw new Error(message);
    }
    invoked = true;
    return fn.apply(this, arguments);
  };
};
